export class ValidationHelperService {
    
    static alphanumericValidator(value){
      const pattern = /[A-Za-z\d\s]/g; /*This RegEx is safe. No need to fix.*/
      return pattern.test(value.trim());
    }
  
  }